import React, { PureComponent, Fragment } from 'react'
import {
  DialogContent,
  DialogActions,
  Button,
  Divider
} from '@material-ui/core'
import { Print as PrintIcon } from '@material-ui/icons'

import { Ticket, PrintWindow } from 'components'

export class PrintTicketsBase extends PureComponent {
  state = {
    isPrintWindow: false
  }

  renderTicket = (booking, i) => {
    const { data: { bookings } } = this.props

    if (bookings.length === 1) {
      return [
        <Ticket key={1} data={booking} index={0} from={booking.from} />,
        <Ticket key={2} data={booking} index={1} from={booking.from} />,
        <Ticket key={3} data={booking} index={2} from={booking.from} />
      ]
    } else {
      return <Ticket key={booking.id} data={booking} index={i} from={booking.from} />
    }
  }

  openPrintWindow = () => this.setState({ isPrintWindow: true })


  renderPrintWindow = bookings => (
    <PrintWindow>
      {bookings.map(this.renderTicket)}
    </PrintWindow>
  )

  render() {
    const { data: { bookings }, onClose } = this.props
    const { isPrintWindow } = this.state

    return (
      <Fragment>

        {isPrintWindow && this.renderPrintWindow(bookings)}

        <DialogActions>
          <Button color='secondary' onClick={onClose}>
            Скасувати
          </Button>
          <Button color='primary' onClick={this.openPrintWindow}>
            Роздрукувати
            <PrintIcon fontSize='small' style={{ marginLeft: 5 }} />
          </Button>
        </DialogActions>

        <Divider />

        <DialogContent>
          {bookings.map(this.renderTicket)}
        </DialogContent>

      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/PrintTickets/PrintTickets.js